<template>
  <div class="media-links-bar">
    <a
      v-for="sm in socialMediaData"
      :key="sm.name"
      class="media-link"
      :href="sm.url"
      :aria-label="`Open Limo Elderg on ${sm.name}`"
      target="_blank"
      rel="noopener noreferrer"
      v-html="sm.svg"
    ></a>
  </div>
</template>

<script>
import { computed } from "vue";
import { toSafeSvg } from "@/utils/safeMarkup";

export default {
  name: "MediaLinksBar",
  props: {
    socialMedias: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const socialMediaData = computed(() => {
      const entries = Object.values(props.socialMedias);
      if (!entries.length) {
        return [];
      }

      return entries.map((media) => ({
        name: media.name,
        url: media.url,
        svg: toSafeSvg(media.svg),
      }));
    });

    return {
      socialMediaData,
    };
  },
};
</script>

<style lang="less" scoped>
.media-links-bar {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.media-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* The svg comes from v-html, so it never receives this component's scope
   attribute and has to be reached with :deep(). */
:deep(.media-link svg) {
  width: 60px;
  height: 60px;
}
</style>